import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useDeleteAreaMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteArea(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useDeleteAreaMutation };
